const es = {
  header: {
    navigation: {
      home: 'Inicio',
      learning: 'Aprendizaje',
      pricing: 'Precios',
      aboutUs: 'Sobre nosotros',
    },
    actions: {
      login: 'Iniciar sesión',
      bookCall: 'Agendar llamada',
    },
    aria: {
      menu: 'menú',
    },
  },
  cta: {
    title: {
      line1: 'Construyamos una Empresa',
      line2: 'Más Inteligente Juntos',
    },
    subtitle: {
      line1: '¿Listo para dejar el caos',
      line2: 'atrás y escalar tu negocio',
      line3: 'con confianza?',
    },
    button: 'Comienza tu viaje con Mr. Wolf hoy',
  },
  auth: {
    signInError: 'Error al iniciar sesión',
    signInErrorDescription: 'Hubo un error al iniciar sesión ¿Estás seguro de que tienes una cuenta?',
    login: 'Ir al Login y volver a intentarlo',
    createAccount: 'Crear mi cuenta ahora',
  },
  login: {
    aiAssistedMessage: 'Documentación de procesos asistida por IA',
    welcomeBack: '¡Bienvenido de vuelta!',
    signInGoogle: 'Iniciar sesión con Google',
    or: 'O',
    email: 'Email',
    enterEmail: 'Introduce tu email',
    password: 'Contraseña',
    rememberMe: 'Recuérdame',
    forgotPassword: '¿Olvidaste tu contraseña?',
    sendResetCode: 'Enviar código de restablecimiento',
    forgotPasswordMessage: 'Introduce tu email para recibir un código de restablecimiento',
    signIn: 'Iniciar sesión',
    resetPassword: 'Restablecer contraseña',
    resetPasswordMessage: 'Introduce tu email y el código de restablecimiento para elegir una nueva contraseña',
    passwordResetCode: 'Código de restablecimiento de contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    enterPasswordResetCode: 'Introduce el código de restablecimiento de contraseña',
    writeNewPassword: 'Escribe tu nueva contraseña',
    confirmNewPassword: 'Confirma tu nueva contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    allFieldsRequired: 'Todos los campos son obligatorios',
    enterTempPassword: 'Introduce la contraseña temporal que recibiste',
    tempPassword: 'Contraseña temporal',
    confirmUserMessage: 'Parece que es la primera vez que inicias sesión, por favor elige una contraseña nueva',
    initialLoginMessage: 'Por favor, introduce tu email y la contraseña temporal que recibiste en tu email',
    confirmUserMessagePasswordRequirements:
      'La contraseña debe tener al menos 8 caracteres y contener al menos una mayúscula, una minúscula, un número y un caracter especial.',
    rememberMeMessage: 'Marca esta casilla para mantener la sesión iniciada en este dispositivo.',
    signUp: 'Registrarse',
    createYourOrganization: 'Crea tu organización',
    signupDescription: 'Comienza tu viaje con Mr. Wolf creando la cuenta de tu organización',
    createAccount: 'Crear Cuenta',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    writePassword: 'Escribe tu contraseña',
    emailVerificationSent: '¡Correo de verificación enviado!',
    checkYourEmail:
      'Por favor revisa tu correo electrónico para verificar tu cuenta y completar el proceso de registro.',
    backToLogin: 'Volver al Login',
    serviceStatus: 'Estado del Servicio',
    accountOwnerInformation: 'Información del Propietario de la Cuenta',
    agreeToTerms: 'Acepto los',
    termsAndConditions: 'Términos y Condiciones',
    and: 'y la',
    privacyPolicy: 'Política de Privacidad',
    mustAcceptTerms: 'Debes aceptar los Términos y Condiciones y la Política de Privacidad para crear una cuenta',
    emailTooltip:
      'Recibirás un correo con una contraseña temporal para iniciar sesión. Si tu email es de Google, también puedes iniciar sesión con tu cuenta de Google.',
  },
  logout: {
    singleWindowPolicy: 'Política de Ventana Única',
    noSessionDetected: 'No se Detectó Sesión',
    noSeatTitle: 'Sin Asiento Activo Asignado',
    singleWindowMessage:
      'Has sido desconectado porque iniciaste sesión desde otra ventana o pestaña del navegador. Solo se permite una sesión activa a la vez por seguridad.',
    noSessionMessage: 'Has sido desconectado porque tu sesión está corrupta o ha expirado.',
    noSeatMessage: 'Acceso denegado: No hay asiento activo asignado. Por favor contacta al administrador de tu organización.',
    securityNote: 'Por tu seguridad, Mr. Wolf aplica una política de sesión de ventana única:',
    policyPoints: {
      oneWindow: 'Solo una ventana/pestaña del navegador puede estar conectada a la vez',
      invalidation: 'Las sesiones anteriores se invalidan automáticamente',
      unauthorized: 'Esto previene el acceso no autorizado a tu cuenta',
    },
    redirectingIn: 'Redirigiendo al login en',
    seconds: 'segundos...',
    loginNow: 'Iniciar Sesión Ahora',
    loggingOut: 'Cerrando sesión...',
  },
  actionMessages: {
    areasReorderedSuccessfully: 'Áreas reordenadas exitosamente',
    areaDeletedSuccessfully: 'Área eliminada existosamente',
    areaCreatedSuccessfully: 'Área creada existosamente',
    areaUpdatedSuccessfully: 'Área actualizada existosamente',
    integrationDeletedSuccessfully: 'Integración eliminada existosamente',
    discrepancyUpdatedSuccessfully: 'Discrepancia actualizada existosamente',
    policyCreatedSuccessfully: 'Política creada existosamente',
    policyUpdatedSuccessfully: 'Política actualizada existosamente',
    policyDeletedSuccessfully: 'Política eliminada existosamente',
    processesReorderedSuccessfully: 'Procesos reordenados existosamente',
    stepCreatedSuccessfully: 'Paso creado existosamente',
    noStepsToExecute: 'No hay pasos para ejecutar',
    stepDeletedSuccessfully: 'Paso eliminado existosamente',
    stepUpdatedSuccessfully: 'Paso actualizado existosamente',
    triggerCreatedSuccessfully: 'Desencadenador creado exitosamente',
    triggerUpdatedSuccessfully: 'Desencadenador actualizado exitosamente',
    processCreatedSuccessfully: 'Proceso creado existosamente',
    processUpdatedSuccessfully: 'Proceso actualizado existosamente',
    stepsReorderedSuccessfully: 'Pasos reordenados existosamente',
    linkSuccessfullyUpdated: 'Link actualizado existosamente',
    deleteSuccessful: 'Eliminación exitosa',
    servicesReorderedSuccessfully: 'Servicios reordenados existosamente',
    serviceCreatedSuccessfully: 'Servicio creado existosamente',
    updateSuccessful: 'Actualización Exitosa',
    avatarUpdatedSuccessfully: 'Avatar actualizado existosamente',
    languageUpdatedSuccessfully: 'Idioma actualizado con éxito',
    profileUpdatedSuccessfully: 'Perfil actualizado existosamente',
    documentUpdatedSuccessfully: 'Documento actualizado existosamente',
    organizationCreatedSuccessfully: 'Organización creada existosamente',
    organizationDisabledSuccessfully: 'Organización eliminada existosamente',
    organizationEditedSuccessfully: 'Organización editada exitosamente',
    organizationEnabledSuccessfully: 'Organización habilitada existosamente',
    userCreatedSuccessfully: 'Usuario creado existosamente',
    userEditedSuccessfully: 'Usuario editado existosamente',
    userDisabledSuccessfully: 'Usuario eliminado existosamente',
    userEnabledSuccessfully: 'Usuario habilitado existosamente',
    loginNoEmail: 'No hay un email. Por favor, introduce un email y presiona ¿Olvidaste tu contraseña nuevamente?',
    fillPolicyFields: 'Por favor, llena el nombre y agrega algún contenido en la política',
    fillAreaFields: 'Por favor, llena el nombre y la descripción del área y elige un color',
    fillServiceFields: 'Por favor elige un área, llena el nombre y la descripción del servicio y elige un color',
    requestError: 'Error en la solicitud de red. Por favor, intenta nuevamente',
    whileImpersonatingError: 'No puedes realizar esta acción mientras estás en modo de suplantación',
    linkCopied: 'Enlace copiado al portapapeles',
    impersonateFailed: 'Error al suplantar',
    impersonateCleared: 'Se dejó de suplantar',
    impersonateClearFailed: 'Error al dejar de suplantar, cerrando sesión...',
    staleImpersonationCleared: 'La suplantación fue cancelada debido a la recarga de página',
    youMustFirstSaveTheStep: 'No se puede borrar. Debes guardar el paso primero',
    cannotDeleteOnlyStep: 'No se puede eliminar el único paso de un proceso',
    generatedFromClearSuccess: 'Generado desde borrado con éxito',
    stepNameRequired: '"¿Qué sucede aquí?" es requerido',
    nameDescriptionColorRequired: 'Nombre, descripción y color son requeridos',
    processNameGoalServiceRequired: 'Nombre del proceso, objetivo y servicio son requeridos',
    triggerNameRequired: 'El nombre del desencadenador es requerido',
    triggerNameExists: 'Ya existe un desencadenador con este nombre. Por favor elige un nombre diferente.',
    invalidOrganizationData: 'Error. Asegúrate de tener un nombre, email, nombre y apellido y que el email sea válido.',
    invalidEmail: 'Por favor introduce una dirección de email válida',
    accountCreatedSuccessfully:
      '¡Cuenta creada exitosamente! Revisa tu email para las instrucciones de inicio de sesión.',
    userAlreadyExists: 'Este email no está disponible. Si ya estás registrado, por favor inicia sesión.',
    changesSavedSuccessfully: 'Cambios guardados con éxito',
    failedLoginAttemptsReset: 'Intentos de inicio de sesión restablecidos con éxito',
    passwordUpdatedSuccessfully: 'Contraseña actualizada con éxito',
    processClonedSuccessfully: 'Proceso clonado con éxito',
    processStatusUpdated: 'Estado del proceso actualizado con éxito',
    processStatusUpdateError: 'Error al actualizar el estado del proceso',
    processStatusUpdateSuccess: 'Estado del proceso actualizado con éxito',
    feedbackSubmittedSuccessfully: 'Comentarios enviados con éxito',
    feedbackMinimalLength: 'El feedback debe ser de al menos 5 caracteres',
    userRoleUpdatedSuccessfully: 'Rol de usuario actualizado exitosamente',
    userRemovedFromOrganizationSuccessfully: 'Usuario removido de la organización exitosamente',
    userAddedToOrganizationSuccessfully: 'Usuario agregado a la organización exitosamente',
    userRestoredToOrganizationSuccessfully: 'Usuario restaurado a la organización exitosamente',
    switchedToOrganization: 'Cambiado a organización',
    failedToSwitchOrganization: 'Error al cambiar de organización. Por favor intenta de nuevo.',
    fileTooLarge: 'El archivo es demasiado grande. Por favor selecciona un archivo más pequeño.',
  },
  areas: {
    title: 'Áreas',
    addNew: 'Agregar nueva área',
    edit: 'Editar área',
    activity: 'Actividad reciente',
    noActivity: 'No hay actividad reciente. Aquí se mostrarán las acciones recientes.',
    createArea: 'Crear área',
    editArea: 'Editar área',
    servicesInside: 'Servicios dentro del área',
    emptyAreaMessage: 'Esta organización no contiene áreas aún, crea una para empezar.',
    name: '¿Cómo se llama este área?',
    description: 'Describe qué hace este área',
    color: '¿Qué color debería representar este área?',
  },
  integrations: {
    title: 'Integraciones',
    type: 'Clase de integración',
    provider: 'Proveedor',
    status: 'Estado',
    structure: 'Estructura',
    clickToEnable: 'Habilitar',
    refreshAfterOAuthMessage: 'Después de completar el flujo de integración, si no lo ves conectado aquí, por favor actualiza la página.',
    clickToGenerateStructure: 'Generar estructura',
    generatingInProgress: 'Generando estructura...',
    generatingInProgressTooltip: 'La generación de estructura está en progreso. Esto puede tomar unos minutos. Por favor espera antes de realizar cualquier otra acción.',
    generationFailed: 'La generación falló. Por favor elimina e intenta de nuevo.',
    enabledGenerated: 'Habilitado y estructura generada',
    integrationDone: 'Integración completada',
    success: 'Integración activada con éxito, ahora puedes cerrar esta pestaña',
    enablingIntegration: 'Espera, habilitando la integración',
    error: 'Error de integración, por favor intenta más tarde',
    checksTitle: 'Comprobaciones de integraciones',
    confirmDelete: '¿Estás seguro de que quieres borrar esta integración?',
    confirmDeleteMessage: 'Esto eliminará la integración existente de tipo {type} con {provider}.',
    confirmDeleteMessageCalendar:
      'La aplicación dejará de vincularse a tu cuenta de calendario, sin embargo, tus calendarios no se borrarán. Si deseas eliminar el calendario de cada servicio, debes hacerlo manualmente.',
    confirmDeleteMessageStorage:
      'La aplicación dejará de actualizarse en tu almacenamiento, sin embargo, tus carpetas no se borrarán. Las carpetas para cada área (con subcarpetas para servicios) así como tu carpeta de políticas globales y plantillas permanecerán. Si lo deseas, puedes eliminarlas manualmente.',
    confirmGenerate: '¿Configurar integración?',
    confirmGenerateMessage:
      'Crearemos y configuraremos la integración {type} con {provider}. Tus datos existentes no se verán afectados.',
    confirmGenerateMessageCalendar:
      'Crearemos:\n• Un calendario para cada servicio en tu organización\n• Eventos de calendario para todos los procesos activados por calendario\n\nTus calendarios existentes no se verán afectados.\n\nSi ya tenías calendarios configurados para tus servicios, intentaremos usarlos en lugar de crear nuevos.',
    confirmGenerateMessageStorage:
      'Crearemos la siguiente estructura de carpetas:\n• Una carpeta para cada área (con subcarpetas de servicios)\n• Una carpeta global de políticas\n• Una carpeta de plantillas\n• Documentos para todas las políticas y procesos\n\nTus archivos existentes no se verán afectados.',
    confirmGenerateBackgroundNote:
      'Este proceso continuará en segundo plano. Por favor espera unos minutos para que se complete. Puedes cerrar este diálogo y continuar trabajando.',
    generateTooltip: 'Creará una estructura para la integración, haz clic para ver detalles',
    connectedAccount: 'Cuenta conectada',
    connectedAs: 'Conectado como {email}',
    connectedOn: 'Conectado el {date}',
    connectedBy: 'por {name}',
    recheckDiscrepancies: 'Rechequeo manual de discrepancias',
    recheckSuccess: 'Rechequeo de discrepancias completado exitosamente',
    recheckDisabledMessage: 'Recientemente actualizaste manualmente. Podrás hacerlo nuevamente en unos minutos.',
    filterDocument: 'Filtrar por nombre de documento',
    showInactive: 'Mostrar inactivos',
    ignore: 'Posponer',
    discrepancyParentType: 'Tipo de discrepancia',
    integrationType: 'Tipo de integración',
    createdAt: 'Creado en',
    involvedDocument: 'Documento involucrado',
    foundDiscrepancy: 'Discrepancia encontrada',
    solution: 'Solución',
    ignorePermanently: 'Posponer permanentemente',
    ignoreMonth: 'Posponer por 1 mes',
    ignoreDay: 'Posponer por 1 día',
    ignoreCustom: 'Posponer por período personalizado',
    trustIntegration: 'Descartar sugerencias',
    goToProcess: 'Go to Process',
    generatingStorageStructure: 'Generando estructura de almacenamiento...',
    generatingStorageMessage1: 'Creando carpetas de áreas...',
    generatingStorageMessage2: 'Configurando subcarpetas de servicios...',
    generatingStorageMessage3: 'Creando documentos de políticas...',
    generatingStorageMessage4: 'Generando documentos de procesos...',
    generatingStorageMessage5: 'Finalizando estructura...',
    generatingCalendarStructure: 'Generando estructura de calendario...',
    generatingCalendarMessage1: 'Buscando calendarios existentes...',
    generatingCalendarMessage2: 'Creando calendarios de servicios...',
    generatingCalendarMessage3: 'Configurando permisos de calendario...',
    generatingCalendarMessage4: 'Creando eventos de calendario...',
    generatingCalendarMessage5: 'Vinculando desencadenadores a eventos...',
    generatingCalendarMessage6: 'Finalizando estructura...',
    // Health status
    healthStatus: 'Salud',
    healthHealthy: 'Saludable',
    healthUnhealthy: 'No saludable',
    healthUnknown: 'Desconocido',
    healthHealthyDescription: 'La integración funciona normalmente. Las operaciones recientes se completaron con éxito.',
    healthUnhealthyDescription: 'La integración ha fallado 5 o más veces seguidas. Verifica tu conexión o vuelve a autenticarte.',
    healthUnknownDescription: 'Sin actividad reciente. El estado se actualizará después de la próxima operación.',
    failedAttempts: '{count} intentos fallidos',
    lastChecked: 'Última verificación: {time}',
    justNow: 'justo ahora',
    minutesAgo: 'hace {count}m',
    hoursAgo: 'hace {count}h',
    daysAgo: 'hace {count}d',
    slackDescription: 'Enviar notificaciones a usuarios por mensaje directo de Slack',
    slackInternalOnlyTooltip: 'La integración con Slack puede no estar disponible para ti. Si no lo está, el soporte para habilitarla en tu organización estará disponible pronto.',
    confirmDeleteMessageSlack:
      'Las notificaciones de Slack se deshabilitarán para todos los usuarios en esta organización. Los usuarios ya no recibirán mensajes directos de Slack para asignaciones de procesos y recordatorios.',
    slackConnectedSuccess: '¡Slack conectado exitosamente!',
    slackConnectionFailed: 'La conexión de Slack falló: {error}',
  },
  discrepancies: {
    title: 'Discrepancias y Acciones Pendientes',
    type: 'Clase de discrepancia',
    provider: 'Proveedor',
    status: 'Estado',
    structure: 'Estructura',
    types: {
      PROCESS_IMPROVEMENT: {
        label: 'Mejora de Proceso',
        message: 'Mejoras sugeridas para este proceso',
        optionWolf: {
          label: 'Mejorar con sugerencias',
          message: 'Edita el proceso para aplicar estas mejoras',
        },
        optionWolfProcessPage: {
          label: 'Ya lo ajusté',
          message: 'Marcar estas mejoras como aplicadas',
        },
        optionIgnore: {
          label: 'Descartar sugerencias',
          message: 'Estas mejoras no son relevantes ahora',
        },
      },
      POLICY_NOT_FOUND: {
        label: 'Política No Encontrada',
        message: 'No se pudo encontrar la política referenciada',
        optionWolf: {
          label: 'Crear política',
          message: 'Crear el documento de política faltante',
        },
        optionIgnore: {
          label: 'Posponer',
          message: 'Posponer creación de política para después',
        },
      },
      POLICY_NOT_CREATED: {
        label: 'Política No Creada',
        message: 'La política aún no ha sido creada',
        optionWolf: {
          label: 'Crear política ahora',
          message: 'Generar el documento de política',
        },
        optionIgnore: {
          label: 'Posponer',
          message: 'Posponer creación de política para después',
        },
      },
      PROCESS_NOT_UPDATED: {
        label: 'Proceso No Actualizado',
        message: 'El proceso necesita ser actualizado',
        optionWolf: {
          label: 'Actualizar proceso',
          message: 'Aplicar las actualizaciones sugeridas a este proceso',
        },
        optionIgnore: {
          label: 'Mantener versión actual',
          message: 'Mantener el proceso como está por ahora',
        },
      },
      TRIGGER_CALENDAR_NOT_FOUND: {
        label: 'Evento de Calendario No Encontrado',
        message: 'El disparador hace referencia a un evento y calendario que ya no existe',
        optionWolf: {
          label: 'Regenerar evento y calendario',
          message: 'Crear un nuevo evento y calendario para este disparador',
        },
        optionIgnore: {
          label: 'Limpiar referencia del evento',
          message: 'Eliminar la referencia al calendario de este disparador',
        },
      },
    },
    clickToEnable: 'Habilitar',
    clickToGenerateStructure: 'Generar estructura',
    enabledGenerated: 'Habilitado y estructura generada',
    integrationDone: 'Integración completada',
    success: 'Integración activada con éxito, ahora puedes cerrar esta pestaña',
    checksTitle: 'Comprobaciones de Discrepancias',
    pendingsTitle: 'Pendientes',
    solveDiscrepancy: 'Resolver Discrepancia',
    pendingsTooltip: 'Acciones que quedaron pendientes cuando interactuaste con Mr. Wolf',
    checksTooltip: 'Comprobaciones automáticas que identifican inconsistencias entre Mr. Wolf y tus integraciones o otras posibles mejoras',
    confirmDelete: '¿Estás seguro de que quieres borrar esta discrepancia?',
    confirmDeleteMessage: 'Esto eliminará la discrepancia existente de tipo {type} con {provider}.',
    confirmGenerate: '¿Reparar configuración de integración?',
    confirmGenerateMessage:
      'Crearemos y configuraremos la integración {type} con {provider}. Tus datos existentes no se verán afectados.',
    confirmGenerateMessageCalendar:
      'Crearemos:\n• Un calendario para cada servicio en tu organización\n• Eventos de calendario para todos los procesos activados por calendario\n\nTus calendarios existentes no se verán afectados.',
    confirmGenerateMessageStorage:
      'Crearemos la siguiente estructura de carpetas:\n• Una carpeta para cada área (con subcarpetas de servicios)\n• Una carpeta global de políticas\n• Una carpeta de plantillas\n• Documentos para todas las políticas y procesos\n\nTus archivos existentes no se verán afectados.',
    confirmGenerateBackgroundNote:
      'Este proceso continuará en segundo plano. Por favor espera unos minutos para que se complete. Puedes cerrar este diálogo y continuar trabajando.',
    generateTooltip: 'Creará una estructura para la integración, haz clic para ver detalles',
    recheckDiscrepancies: 'Rechequeo manual de discrepancias',
    recheckSuccess: 'Rechequeo de discrepancias completado exitosamente',
    recheckDisabledMessage: 'Recientemente actualizaste manualmente. Podrás hacerlo nuevamente en unos minutos.',
    filterDocument: 'Filtrar por nombre de documento',
    showInactive: 'Mostrar inactivos',
    ignore: 'Posponer',
    discrepancyParentType: 'Tipo de discrepancia',
    integrationType: 'Tipo de integración',
    integrationTypes: {
      CALENDAR: 'Calendario',
      STORAGE: 'Almacenamiento',
      NOTES: 'Notas',
      ISSUE_TRACKER: 'Gestor de Incidencias',
      OTHER: 'Otro',
    },
    entities: {
      Trigger: 'Disparador',
      Process: 'Proceso',
      Policy: 'Política',
      Service: 'Servicio',
      Area: 'Área',
    },
    createdAt: 'Creado en',
    involvedDocument: 'Documento involucrado',
    foundDiscrepancy: 'Discrepancia encontrada',
    solution: 'Solución',
    optionInteg: 'Arreglar mediante acción del usuario',
    pendingType: 'Tipo',
    pendingName: 'Nombre',
    pendingStatus: 'Estado',
    pendingDate: 'Fecha',
    pendingActions: 'Acciones',
    completePending: 'Completar',
    continuePending: 'Continuar',
    completePendingTooltip: 'Marcar como completado y eliminar de la lista de pendientes',
    continuePendingTooltip: 'Interrumpirá la conversación actual de Mr. Wolf y continuará con esta acción pendiente',
    continuingPending: 'Continuando acción pendiente...',
    ignorePermanently: 'Posponer permanentemente',
    ignoreMonth: 'Posponer por 1 mes',
    ignoreDay: 'Posponer por 1 día',
    ignoreCustom: 'Posponer por período personalizado',
    trustIntegration: 'Descartar sugerencias',
    okDoneIt: 'Ok ya lo hice',
    remindInDay: 'Recordarme en un día',
    remindInMonth: 'Recordarme en un mes',
    discardPermanently: 'Descartar permanentemente',
    discrepancies: 'Discrepancias',
    possibleImprovements: 'Posibles mejoras',
  },
  policies: {
    addPolicy: 'Agregar política',
    category: 'Categoría de política',
    confirmDeleteTitle: 'Confirmar eliminación',
    confirmDeleteMessage:
      '¿Estás seguro de que quieres borrar esta política? Ten en cuenta que está referenciada en {count} procesos.',
    content: 'Contenido',
    description: 'Descripción',
    policyContent: 'Contenido de la política',
    usedIn: 'Política usada en los siguientes procesos',
    view: 'Ver política',
    contentTooltip: 'El contenido de la política, todas las reglas que define la política',
    descriptionTooltip: 'La descripción de la política, una breve explicación de lo que cubre',
    categoryTooltip:
      'La categoría de la política, para que pueda ser agrupada con otras que cubren los mismos problemas (e.g. "Normativa", "Gestión de Riesgos", "IT", etc.)',
    name: '¿Cómo se llama esta política?',
    policyDescription: 'Describe qué cubre esta política',
    policyCategory: '¿Cómo se debería categorizar esta política?',
    policyContentLabel: '¿Cuáles son las reglas definidas por esta política?',
    emptyPolicyMessage: 'Esta organización no tiene políticas aún, crea una para empezar.',
  },
  processes: {
    title: 'Procesos',
    addNew: 'Agregar nuevo proceso',
    edit: 'Editar proceso',
    editTriggers: 'Edit Triggers',
    addStep: 'Agregar paso',
    allServices: 'Todos los servicios',
    searchPlaceholder: 'Buscar por nombre u objetivo',
    expandAll: 'Expandir todo',
    collapseAll: 'Contraer todo',
    normalStep: 'Paso normal',
    caseStep: 'Paso de caso',
    loopStep: 'Paso de bucle',
    condition: 'Condiciones',
    noCondition: 'No hay condiciones para este paso',
    notes: 'Notas',
    noNotes: 'No hay notas para este paso',
    policiesLinked: 'Políticas vinculadas',
    linkedProcess: 'Proceso vinculado',
    linkedToProcess: 'Proceso vinculado',
    noLinked: 'No hay procesos vinculados',
    noTriggersYet: 'Aún no hay desencadenadores definidos.',
    generatedFrom: 'Generado a partir del documento',
    aNewStep: 'Un nuevo paso',
    aNewRepeatStep: 'Un nuevo paso de bucle',
    aNewSwitchStep: 'Nuevo caso',
    aNewCondition: 'Nueva condición',
    conditionPrefix: 'Condición',
    generatedFromClear:
      'Proceso generado a partir de documento, haz clic aquí para borrar esta referencia si ya no es relevante',
    noPoliciesYet: 'No hay políticas vinculadas',
    policiesClear: 'Haz clic para desvincular esta política del proceso',
    selectPolicy: 'Seleccionar política',
    noRecurrence: 'No hay repetición definida',
    saveStepBeforeMoving: 'Debes guardar el paso antes de intentar moverlo',
    markAsApproved: 'Marcar como aprobado',
    markAsLocked: 'Marcar como bloqueado',
    markAsDraft: 'Marcar como borrador',
    markProcessAsApproved: 'Marcar como aprobado',
    markProcessAsApprovedConfirmation: '¿Quieres marcar este proceso como aprobado?',
    markProcessAsDone: 'Marcar como aprobado',
    markProcessAsDoneConfirmation: '¿Quieres marcar este proceso como aprobado?',
    markProcessAsDoneCancel: 'No, dejar como borrador',
    markProcessAsDoneConfirm: 'Sí, marcar como aprobado',
    emptyProcessMessage: 'No hay procesos para mostrar aún.',
    createServicesFirst: 'Necesitas crear servicios primero',
    dropPlaceAtStart: 'Suelta aquí para colocar al inicio',
    dropPlaceAtEnd: 'Suelta aquí para colocar al final',
    dropInsideStep: 'Soltar dentro de {stepName}',
    dropBelowStep: 'Agregar debajo de {stepName}',
    cannotMoveContainerInside: 'No se pueden mover pasos contenedores dentro de otros pasos',
    markExecution: 'Ejecutar',
    processFoundInOtherOrg: 'Proceso encontrado en {organizationName}',
    switchToOrganization: 'Cambiar a esa organización',
    processNotFound: 'Proceso No Encontrado',
    processNotFoundInAnyOrg: 'Proceso no encontrado en ninguna de sus organizaciones',
    processNotFoundMessage: 'El proceso que busca no existe o no tiene acceso a él.',
    executionTracking: 'Seguimiento de Ejecución',
    startExecution: 'Iniciar Ejecución',
    startingExecution: 'Iniciando ejecución...',
    executeProcess: 'Ejecutar Proceso',
    stepExecution: 'Sus notas sobre la ejecución',
    markStepDone: 'Completado',
    markStepNotDone: 'Omitido',
    markStepWithError: 'Completado con problemas',
    stepDone: 'Hecho',
    stepNotDone: 'No Hecho',
    stepWithError: 'Error',
    stepPending: 'Pendiente',
    stepInProgress: 'En Progreso',
    stepSkipped: 'Omitido',
    currentStep: 'Paso Actual',
    executionNote: 'Nota de Ejecución',
    backToPreviousStep: 'Volver al paso anterior',
    goBackStepSuccess: 'Volviste al paso anterior',
    goBackStepNoPrevious: 'No hay paso anterior al cual volver',
    yourExecutionNotes: 'Tus notas sobre esta ejecución',
    addNotes: 'Algo que merezca mencionarse (opcional)',
    confirmStartExecution: 'Iniciar Ejecución del Proceso',
    confirmStartExecutionMessage: 'Estás a punto de iniciar la ejecución de este proceso. ¿Deseas continuar?',
    errorDetails: 'Detalles del Error',
    completeExecution: 'Completar Ejecución',
    executionCompleted: 'Ejecución marcada como Completada',
    executionFailed: 'Ejecución marcada como Fallida',
    executionCancelled: 'Ejecución marcada como Cancelada',
    emptyContainerStepsWarning: 'No se puede iniciar la ejecución. Los siguientes pasos no tienen subpasos configurados: {steps}',
    selectExecutionStatus: 'Seleccionar Estado de Ejecución',
    selectExecutionStatusMessage: 'Algunos pasos no se completaron o tuvieron errores. ¿Cómo desea marcar esta ejecución?',
    markAsCompleted: 'Marcar como Completada',
    markAsFailed: 'Marcar como Fallida',
    markAsCancelled: 'Marcar como Cancelada',
    closeExecution: 'Cerrar',
    lastExecution: 'Ejecutado el',
    updatedOn: 'Actualizado el',
    recentlyUpdatedTooltip: 'Este proceso fue modificado en el último mes. Por favor, revísalo con atención.',
    viewAllExecutions: 'Ver todas las ejecuciones',
    viewExecutions: 'Ver ejecuciones',
    noExecutionsYet: 'Sin ejecuciones aún',
    executionHistory: 'Historial de Ejecuciones',
    assignedByMe: 'Asignados Por Mí',
    assignedTo: 'Asignado a',
    noAssignedExecutions: 'No hay ejecuciones asignadas por ti',
    startedBy: 'Iniciado por',
    startedByAssignedTo: 'Ejecutado Por',
    executedBy: 'Ejecutado por',
    duration: 'Duración',
    viewDetails: 'Ver Detalles',
    noSteps: 'Sin pasos registrados',
    startExecutingProcesses: 'Comience a ejecutar procesos para ver su historial aquí',
    forExecution: 'Para Ejecución',
    markStuckExecutionAsCompletedTooltip: 'Marcar esta ejecución como completada',
    markStuckExecutionAsFailedTooltip: 'Marcar esta ejecución como fallida',
    markStuckExecutionAsCancelledTooltip: 'Marcar esta ejecución como cancelada',
    stepControl: '¿Cómo sabrás que se ejecutó este paso?',
    confirmationType: 'Sólo un comentario opcional',
    confirmationTypeNone: 'Sin control adicional',
    confirmationTypeBoolean: 'Comentario opcional y confirmación explícita',
    confirmationTypeCustomText: 'Comentario opcional y pedir información específica',
    confirmationQuestion: 'Pregunta de Confirmación',
    checkboxControlLabel: 'Lo que el usuario debe confirmar',
    customTextLabel: '¿Qué información debe proveer el usuario?',
    confirmationQuestionPlaceholder: 'ej., "Ingrese el número de transacción del sistema de pagos:"',
    confirmationQuestionBooleanPlaceholder: 'ej., "¿Ha revisado y aprobado el contrato?"',
    confirmationRequired: 'Por favor, confirme que',
    confirmationResponse: 'Confirmación',
    confirmed: 'Confirmado',
    notConfirmed: 'No confirmado',
    confirmationCheckRequired: 'Por favor, marque la casilla para completar este paso',
    confirmationTextRequired: 'Por favor, proporcione la confirmación requerida',
    requireConfirmation: '¿Requiere confirmación?',
    print: 'Imprimir',
    printProcess: 'Imprimir Proceso',
    printPreview: 'Vista Previa de Impresión',
    linkedProcessOpensInNewTab: 'El proceso vinculado se abrirá en una nueva pestaña para preservar la ejecución actual',
    versionHistory: 'Historial de Versiones',
    versionHistoryTooltip: 'Su lista de versiones de este documento',
    version: 'Versión',
    versionColumnTooltip: 'Los saltos menores y mayores se determinan según sus cambios',
    currentVersion: 'Versión Actual',
    active: 'Activa',
    activeVersionTooltip: 'Los cambios realizados en los próximos minutos se incluirán en esta versión',
    versionCreatedBy: 'Creado por',
    versionDescription: 'Descripción del Cambio',
    versionCreated: 'Versión {version} creada',
    showAllExecutions: 'Mostrar todas',
    searchByUser: 'Buscar por usuario',
    filterByUser: 'Filtrar por usuario',
    filterByProcess: 'Filtrar por proceso',
    searchByProcess: 'Buscar por proceso',
    filterByArea: 'Filtrar por área',
    searchByArea: 'Buscar por área',
    filterByService: 'Filtrar por servicio',
    searchByService: 'Buscar por servicio',
    filterByDate: 'Filtrar por fecha',
    includedExecutionDates: 'Fechas de ejecución incluidas',
    filterByStatus: 'Filtrar por estado',
    filters: 'Filtros',
    statuses: 'Estados',
    multiple: 'Múltiples',
    users: 'Usuarios',
    processes: 'Procesos',
    areas: 'Áreas',
    services: 'Servicios',
    allTime: 'Todo',
    today: 'Hoy',
    last7Days: 'Últimos 7 días',
    last30Days: 'Últimos 30 días',
    customRange: 'Personalizado',
    assigned: 'Asignada',
    in_progress: 'En Progreso',
    failed: 'Fallida',
    cancelled: 'Cancelada',
    skipped: 'Saltada',
    from: 'Desde',
    to: 'Hasta',
    clearFilters: 'Limpiar filtros',
    noExecutionsMatchingFilters: 'No hay ejecuciones que coincidan con los filtros seleccionados',
    groupByProcess: 'Agrupar por proceso',
    groupByUser: 'Agrupar por usuario',
    executionsForUser: 'Ejecuciones de',
    myExecutions: 'Mis Ejecuciones',
    myExecutionHistory: 'Mi Historial de Ejecuciones',
    clearFilter: 'Limpiar filtro',
    executionByAnotherUser: 'Ejecución de otro usuario',
    redactedExecution: 'Detalles ocultos',
    requestExecution: 'Solicitar Ejecución',
    requestExecutionTitle: 'Solicitar Ejecución',
    selectAssignee: 'Seleccionar Asignado',
    selectUserToExecuteProcess: 'Selecciona un usuario para asignarle la ejecución de este proceso',
    executionRequestedSuccessfully: 'Ejecución solicitada exitosamente',
    selectUserBeforeRequesting: 'Por favor selecciona un usuario',
    errorRequestingExecution: 'Error al solicitar ejecución',
    noUsersAvailable: 'No hay usuarios disponibles para asignar',
    notifyAssigneeByEmail: 'Notificar al asignado por correo',
    addNoteOptional: 'Agregar una nota (opcional)',
    notePlaceholder: 'Escribe un mensaje para el asignado...',
    startAssignedExecution: 'Iniciar',
    continueExecution: 'Continuar',
    noteFromAssigner: 'Nota del Asignador',
    startFresh: 'Comenzar de Nuevo',
    pendingActions: 'Mis Acciones Pendientes',
    pendingActionsTooltip: 'Ejecuciones asignadas a ti o que iniciaste y están actualmente en progreso',
    myExecutionHistoryTooltip: 'Tus ejecuciones en todos los estados. Usa los filtros de estado para reducir',
    myWatchlistTooltip: 'Ejecuciones de procesos que estás siguiendo y ejecuciones que asignaste a otros',
    allExecutionsTooltip: 'Todas las ejecuciones en la organización. Usa los filtros para reducir por proceso, usuario, estado, área, servicio o fecha',
    tabsView: 'Vista en Pestañas',
    stackedView: 'Vista Apilada',
    executionControl: 'Control de Ejecuciones',
    myWatchlist: 'Mi Lista de Seguimiento',
    addToWatchlist: 'Agregar a Lista de Seguimiento',
    removeFromWatchlist: 'Quitar de Lista de Seguimiento',
    addedToWatchlist: 'Agregado a la lista de seguimiento',
    removedFromWatchlist: 'Quitado de la lista de seguimiento',
    watchingProcess: 'Siguiendo este proceso',
    processWatchlistTooltip: 'Recibe notificaciones sobre las ejecuciones de este proceso',
    allExecutions: 'Todas las Ejecuciones',
    assignedBy: 'Asignado Por',
    assignedToYou: 'Asignado a ti',
    continuingPreviousExecution: 'Continuando tu ejecución anterior',
    startingAssignedExecution: 'Iniciando tu ejecución asignada',
    confirmStartAssignedExecution: 'Iniciar Ejecución Asignada',
    confirmContinueExecution: 'Continuar Ejecución',
    confirmStartAssignedExecutionMessage: 'Tienes una ejecución asignada. ¿Te gustaría iniciarla ahora?',
    confirmContinueExecutionMessage: 'Tienes una ejecución en progreso iniciada el',
    continueOrStartNew: '¿Te gustaría continuar o comenzar una nueva?',
    startOver: 'Comenzar de Nuevo',
    startOverTooltip: 'Marcar la anterior como cancelada y comenzar de nuevo',
    iteration: 'Iteración',
    completed: 'Completada',
    addAnotherIteration: 'Repetir una vez más',
    doneNoMore: 'Continuar al paso siguiente',
    repeatStep: 'Paso Repetir',
    switchStep: 'Paso Switch',
    skipExecution: 'Saltar Pasos',
    skipExecutionMessage: 'Selecciona los pasos que deseas saltar. Opcionalmente puedes agregar notas.',
    noSkippableSteps: 'No hay pasos disponibles para saltar',
    selectAll: 'Seleccionar todo',
    unnamedStep: 'Paso sin nombre',
    skipExecutionNotesPlaceholder: 'Notas opcionales sobre por qué se saltan estos pasos...',
    cancel: 'Cancelar',
    skipping: 'Saltando...',
    skipSelected: 'Saltar Seleccionados',
    skip: 'Saltar',
    missingTriggerId: 'Falta el ID del disparador. Por favor verifica tu enlace.',
    executionSkippedSuccess: 'Ejecución saltada exitosamente para hoy.',
    executionSkippedError: 'Error al saltar la ejecución.',
    processingSkip: 'Procesando Solicitud de Salto',
    pleaseWait: 'Por favor espera...',
    executionSkipped: 'Ejecución Saltada',
    skipFailed: 'Fallo al Saltar',
    saveFirstStepBeforeAdding: 'Guarda el paso actual antes de agregar más',
  },
  processForm: {
    name: '¿Cómo se llama este proceso?',
    goal: '¿Cuál es el objetivo de este proceso?',
    category: '¿Cómo debe categorizarse este proceso?',
    description: 'Describe qué hace este proceso',
    calenEvTriggers: 'Desencadenadores de calendario / evento',
    evTrig: 'Desencadenador de evento',
    evTrigName: 'Nombre del desencadenador de evento',
    evTrigNamePlaceholder: 'Un correo electrónico de un cliente',
    evTrigDescription: 'Descripción del desencadenador (opcional)',
    calTrig: 'Desencadenador de calendario',
    triggeredFrom: 'Desencadenado por estos procesos',
    createProcess: 'Crear proceso',
    moveProcessTooltip: 'Haz clic aquí para mover el proceso a otra área/servicio',
    editProcess: 'Editar proceso',
    serviceForProcess: '¿A qué servicio contiene este proceso?',
    selectService: 'Seleccionar servicio',
    stepName: '¿Qué sucede aquí? (nombre del paso)',
    caseName: 'Nombre del caso',
    loopName: 'Nombre del bucle',
    conditionName: 'Nombre de la condición',
    linkedProcess: '¿Se debe ejecutar otro proceso?',
    selectProcess: 'Seleccionar proceso',
    stepNotes: 'Notas y aclaraciones extra',
    stepNotesExplain: 'Agrega contexto útil, recordatorios o aclaraciones',
    stepCondition: '¿Aplicar este paso depende de alguna condición?',
    stepConditionExplain: 'Especifica las condiciones que deben cumplirse para este paso',
    stepContent: 'Describe cómo hacerlo',
    stepContentTooltip: 'Escribe una explicación clara de cómo realizar este paso. Usa viñetas para mayor claridad',
    stepInformationPre: 'Describe ',
    stepInformationBold: 'qué',
    stepInformationPost: ' hacer',
    conditionInformation: 'Describe esta condición',
    caseInformation: 'Describe este caso',
    loopInformation: 'Describe qué se repite',
    removeStep: 'Eliminar paso',
    firstStepRequired: 'Un proceso debe tener al menos un paso, por favor guárdalo',
    unsavedStepChanges: 'Cambios sin guardar',
    unsavedStepChangesMessage: 'Tienes cambios sin guardar en el paso actual. ¿Qué te gustaría hacer?',
    discardAndAddNew: 'Descartar cambios y agregar nuevo',
    saveAndAddNew: 'Guardar y agregar nuevo',
    saveAndSelect: 'Guardar e ir al paso seleccionado',
    discardAndSelect: 'Descartar e ir al paso seleccionado',
    continueEditing: 'Continuar editando',
    linkedPolicy: '¿Qué políticas aplican a este proceso?',
    linkedPolicyMessage:
      'Selecciona las políticas que rigen o guían este proceso. Puedes seleccionar varias políticas.',
    processCategoryMessage: 'Agrupa este proceso con otros procesos relacionados en un flujo de trabajo',
    processGoalMessage: '¿Cuál es el resultado final u objetivo de este proceso?',
    processDescriptionMessage: 'Explica brevemente qué hace este proceso',
    processName: 'Nombre del proceso',
    saveBeforeTriggers: 'Por favor, guarda el proceso antes de administrar los desencadenadores',
  },
  calTrig: {
    name: 'Nombre del desencadenador',
    namePlaceholder: 'Revisión mensual de presupuesto',
    monthlyReminder: '- Recordatorio mensual',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    timezone: 'Zona horaria',
    assignees: 'Asignados (separados por comas)',
    assigneesPlaceholder: 'Ingresa direcciones de correo electrónico separadas por comas',
    selectFromOrganization: 'Selecciona Asignados de tu Organización:',
    selectMember: 'Selecciona un miembro',
    noRepeat: 'Solo se ejecuta una vez',
    currentSelection: 'Selección actual:',
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
    yearly: 'Anual',
    day: 'Día',
    days: 'Días',
    week: 'Semana',
    weeks: 'Semanas',
    year: 'Año',
    years: 'Años',
    dayCriteria: 'Tipo de día',
    byNumber: 'Por número de día',
    byNumberMonth: 'Por número de día del mes',
    byDay: 'Por día de la semana',
    byDayMonth: 'Por día de la semana del mes',
    month: 'Mes',
    repeatEvery: 'Repetir cada',
    repeatFor: 'Repetir durante',
    repeatBy: 'Repetir por',
    number: 'Número',
    frequency: 'Frequency',
    onDays: 'Días de la semana',
    repeatUntil: 'Repetir hasta',
    repeatPattern: 'Repetir',
    repeatPosition: 'Posición de repetición',
    repeat: '¿Cuándo se repite este desencadenador?',
    months: 'Meses',
    every: 'Cada',
    indefinitely: 'Indefinidamente',
    afterTimes: 'Finalizar después de X veces',
    atDate: 'Hasta la fecha',
    triggerOneLine: 'Descripción breve del desencadenador',
    triggerOneLineTooltip: 'Un nombre breve y descriptivo para este desencadenador de calendario (ej. \'Reunión semanal de equipo\', \'Revisión mensual\')',
    triggerDetails: 'Detalles del desencadenador',
    triggerDetailsPlaceholder: 'Detalles adicionales opcionales sobre este desencadenador',
    triggerDetailsTooltip: 'Contexto adicional, notas o instrucciones para este desencadenador de calendario. Esto es opcional pero puede ayudar a clarificar el propósito del desencadenador.',
    start: 'Inicio',
    end: 'Fin',
    onThe: 'En el',
    dayLabel: 'Misma fecha cada mes',
    weekdayLabel: 'Mismo día de la semana cada mes',
    times: 'Veces',
    date: 'Fecha',
    remindAssignee: 'Hacer que Mr. Wolf Recuerde al Asignado',
    reminderInterval: 'Intervalo de recordatorio',
    reminderIntervalValue: 'Enviar recordatorio después de',
    reminderUnit: 'Unidad de tiempo',
    reminderHelpText: 'Si el asignado no ha ejecutado el proceso, Mr. Wolf enviará un recordatorio.',
    reminderMinutes: 'Minutos',
    reminderHours: 'Horas',
    reminderDays: 'Días',
    intervalMustBePositive: 'El intervalo debe ser mayor que 0',
    // Preset option labels
    sevenDays: '7 días',
    onlyWeekdays: 'solo días laborables',
    onDay: 'el día {day}',
    until: 'hasta',
    // Day names for recurrence display
    dayNames: {
      MO: 'Lunes',
      TU: 'Martes',
      WE: 'Miércoles',
      TH: 'Jueves',
      FR: 'Viernes',
      SA: 'Sábado',
      SU: 'Domingo',
    },
    // Month names for recurrence display
    monthNames: {
      '1': 'Enero',
      '2': 'Febrero',
      '3': 'Marzo',
      '4': 'Abril',
      '5': 'Mayo',
      '6': 'Junio',
      '7': 'Julio',
      '8': 'Agosto',
      '9': 'Septiembre',
      '10': 'Octubre',
      '11': 'Noviembre',
      '12': 'Diciembre',
    },
    // Position names for recurrence display
    positionNames: {
      '1': 'Primer',
      '2': 'Segundo',
      '3': 'Tercer',
      '4': 'Cuarto',
      '-1': 'Último',
    },
    // Recurrence text patterns
    recurrencePatterns: {
      everyDay: 'Cada {interval} día',
      everyDays: 'Cada {interval} días',
      everyWeekOn: 'Cada {interval} semana el {days}',
      everyWeeksOn: 'Cada {interval} semanas el {days}',
      everyMonthOnDay: 'Cada {interval} mes el día {day}',
      everyMonthsOnDay: 'Cada {interval} meses el día {day}',
      everyMonthOnThe: 'Cada {interval} mes el {position} {day}',
      everyMonthsOnThe: 'Cada {interval} meses el {position} {day}',
      everyYearOn: 'Cada {interval} año el {day} de {month}',
      everyYearsOn: 'Cada {interval} años el {day} de {month}',
      everyYearOnThe: 'Cada {interval} año el {position} {day} de {month}',
      everyYearsOnThe: 'Cada {interval} años el {position} {day} de {month}',
      noRepetition: 'Sin repetición',
      and: 'y',
    },
  },
  processMap: {
    title: 'Mapa de procesos',
    bezier: 'Bezier',
    straight: 'Recta',
    step: 'Pasos rectos',
    lineStyle: 'Estilo de línea',
    chartDetail: 'Nivel de detalle del gráfico',
    detailedProcessLevel: 'Mostrar detalles de proceso con pasos dentro',
    roughOutlineLevel: 'Mostrar solo procesos',
    v2: 'Mostrar v2!',
    flowMargin: 'Márgen entre categorías (px) - Espacio vertical',
    categoriesAdded: 'Categorías dibujadas actualmente',
    categoriesAddedTooltip: 'Arrastra las categorías para reordenarlas',
    selectService: 'Seleccionar servicio',
    selectArea: 'Seleccionar área',
    selectCategory: 'Seleccionar categoría',
    noCategoriesAddedYet: 'No hay categorías dibujadas aún',
    noTriggersYet: 'No hay desencadenadores definidos para este flujo',
    selectAProcess:
      'Selecciona un proceso desde el menú (o haz clic en el icono del mapa en las tarjetas) para ver algo aquí!',
    noConnectionsWarning: 'No hay conexiones con otros procesos en esta categoría',
    noTriggerDefined: 'No hay disparador definido',
    warning: 'Advertencia',
    addFlowTooltip: 'Agregar el flujo que contiene este proceso al gráfico',
    showFlowTooltip: 'Mostrar el flujo que contiene este proceso (si existe)',
    collapse: 'Contraer',
    showAllSteps: 'Mostrar todos los pasos',
    searchPlaceholder: 'Buscar...',
    expandCollapseMenu: 'Expandir/Contraer menú',
    processLinkedToItself: 'Proceso vinculado a sí mismo',
    processPartOfLoop: 'El proceso es parte de un bucle circular',
    processDraft: 'Este proceso aún es un Borrador',
  },
  services: {
    title: 'Servicios',
    addNew: 'Agregar nuevo servicio',
    edit: 'Editar servicio',
    areaForService: '¿A qué área pertenece este servicio?',
    selectArea: 'Seleccionar área',
    createService: 'Crear servicio',
    editService: 'Editar servicio',
    processesInside: 'Procesos dentro del servicio',
    pickAreaToSeeColors: 'Selecciona un área primero para ver los colores disponibles',
    selectAColorArea:
      'Elige un color para identificar esta área. Los servicios internos usarán tonos de este color.',
    selectAColorService: 'Elige un color para identificar este servicio y sus procesos',
    emptyServiceMessage: 'No hay servicios para mostrar aún.',
    createAreaFirst: 'Necesitas crear áreas primero',
    name: '¿Cómo se llama este servicio?',
    description: 'Describe qué hace este servicio',
    color: '¿Qué color debería representar este servicio?',
  },
  stepItem: {
    notes: 'Notas (Opcional)',
    selectProcess: 'Seleccionar proceso',
    condition: 'Condición',
    conditionPlaceholder: 'Si el elemento revisado no es aprobado',
    requiredWithin: 'Requerido para pasos dentro de un switch',
    linkedProcess: 'Proceso vinculado',
    linkedProcessTiming: '¿Cuándo se ejecuta este proceso?',
    linkedProcessTimingTooltip: 'Cuándo se activará el proceso vinculado: inmediatamente, después de un evento programado, después de recibir un mensaje, o después de otra cosa',
    linkedProcessMed: 'Proceso vinculado mediado por',
    deleteStep: 'Borrar paso',
    editStep: 'Editar paso',
    dragStep: 'Reordenar paso',
    immediate: 'Inmediatamente',
    linkEmail: 'Después de un mensaje',
    linkCalendar: 'Después de un evento programado',
    linkOther: 'Después de otra cosa',
    triggerNameMessage: '¿Cuál es este mensaje?',
    triggerNameMessageTooltip: 'Nombre del mensaje que activa este proceso (ej: "Correo de aprobación del gerente", "Consulta del cliente")',
    triggerNameCalendar: '¿Cuál es este evento programado?',
    triggerNameCalendarTooltip: 'Nombre del evento de calendario que activa este proceso (ej: "Reunión de revisión mensual", "Auditoría trimestral")',
    triggerNameOther: '¿Cuál es este evento?',
    triggerNameOtherTooltip: 'Nombre del evento que activa este proceso (ej: "Alerta del sistema", "Solicitud manual")',
    triggerDescriptionMessage: 'Describe el mensaje',
    triggerDescriptionMessageTooltip: 'Proporciona más detalles sobre el contenido del mensaje o el remitente',
    triggerDescriptionCalendar: 'Describe el evento programado',
    triggerDescriptionCalendarTooltip: 'Proporciona más detalles sobre cuándo y cómo ocurre este evento',
    triggerDescriptionOther: 'Describe el evento',
    triggerDescriptionOtherTooltip: 'Proporciona más detalles sobre qué es este evento y cuándo ocurre',
    conditionRequired: 'Condición requerida',
  },
  summaryCardProcess: {
    cannotReorder: 'No se puede reordenar en procesos desde la vista general, accede a un servicio para reordenar',
    selectPolicy: 'Seleccionar política',
    noTriggers: 'No hay desencadenadores vinculados',
    noPolicies: 'No hay políticas vinculadas',
  },
  summaryCard: {
    cannotReorder:
      'No se puede reordenar en servicios desde la vista de todas las áreas, accede a un área específica para reordenar',
    integration: 'Integración',
    integrationInactiveMessage: 'No tienes una integración activa',
    integrationOfferMessage: '¿Te gustaría configurar tu integración ahora?',
    emptyArea: 'Esta área no contiene servicios dentro',
    emptyService: 'Este servicio no contiene procesos dentro',
    emptyProcess: 'Este proceso no contiene pasos dentro',
    numberPolicies: 'Número de políticas vinculadas a este proceso',
    numberCalendarTriggers: 'Número de disparadores de calendario para este proceso',
    numberEventTriggers: 'Número de disparadores de eventos para este proceso',
  },
  impExp: {
    enterData: 'Introduce los datos a importar',
    resetIds: 'Restablecer IDs',
    resetInteg: 'Restablecer datos de integración',
    skipReorder: 'Saltar reordenación',
    importPos: 'Posición de importación',
    beforeStep: 'Antes del paso',
    integDataMessage: 'Esto mantendrá los datos de importación existentes en el JSON, pudiendo generar inconsistencias',
    exportElem: 'Seleccionar elementos a exportar',
  },
  menu: {
    areas: 'Áreas',
    services: 'Servicios',
    processes: 'Procesos',
    categories: 'Categorías',
    policies: 'Políticas',
    documents: 'Documentos',
    organizations: 'Organizaciones',
    processMap: 'Mapa de Procesos',
    integrations: 'Integraciones',
    discrepancies: 'Discrepancias',
    executions: 'Ejecuciones',
    settings: 'Perfil',
    myOrganization: 'Mi Organización',
    switchOrganization: 'Cambiar Organización',
    createOrganization: 'Crear Organización',
    logout: 'Salir',
    users: 'Usuarios',
    searchResultsMinLength: 'Por favor, introduce al menos 3 caracteres para buscar',
    noResults: 'No results found.',
    stopImpersonate: 'Dejar de suplantar',
    workingAs: 'Advertencia: Estás trabajando como',
    ifReload: 'Si recargas la página, dejarás de suplantar automáticamente',
    stopImpersonating: 'Para permitir el colapso del menú, primero debes dejar de suplantar',
    onboardingProgress: 'Onboarding ',
    ftueCompleted: 'Entrevista Finalizada',
    processCreated: 'Proceso Creado',
    userCreated: 'Usuario Creado',
    executionRequested: 'Ejecución Solicitada',
    triggerAdded: 'Disparador Agregado',
    createProcessFirst: 'Debes crear un proceso primero',
    createUserFirst: 'Debes crear un usuario primero',
    dismissPermanently: 'Ignorar permanentemente',
    dismissForTwoWeeks: 'Ignorar por 2 semanas',
    dismissOnboarding: 'Ignorar pasos de onboarding',
    dismissOnboardingText:
      '¿Estas seguro de que quieres quitar el recordatorio de onboarding? Selecciona si deseas ignorarlo permanentemente o por dos semanas.',
    updateProfile: 'Tu perfil tiene más de 90 días, recomendamos ir a "Mi organización" para actualizarlo.',
    onboarding: 'Primeros pasos',
    onboardingTasksCompleted: 'Tareas de incorporación completadas',
    collapseTooltip: 'Haz clic para contraer el panel lateral',
    expandTooltip: 'Haz clic para expandir el panel lateral',
    searchTooltip: 'Haz clic para buscar procesos, áreas, servicios, etc.',
    reportIssue: 'Reportar Problema',
    billing: 'Facturación',
    subscriptions: 'Suscripciones',
    viewFeedback: 'Ver Comentarios',
  },
  feedback: {
    title: 'Enviar Comentarios',
    pageTitle: 'Comentarios de Usuarios',
    ratingLabel: 'Calificación (opcional)',
    typeLabel: 'Tipo de Comentario',
    commentLabel: 'Comentario (opcional)',
    commentPlaceholder: 'Cuéntanos qué piensas...',
    minCommentLength: 'El comentario debe tener al menos 5 caracteres',
    typeBug: 'Reporte de Error',
    typeComment: 'Comentario',
    typeSuggestion: 'Sugerencias',
    typeFeatureRequest: 'Solicitud de Función',
    typeImprovement: 'Sugerencia de Mejora',
    typeOther: 'Otro',
    tableUser: 'Usuario',
    tableType: 'Tipo',
    tableRating: 'Calificación',
    tableComment: 'Comentario',
    tableDate: 'Fecha',
    noFeedback: 'Aún no hay comentarios enviados',
  },
  settings: {
    changeAvatar: 'Cambiar Avatar',
    saveAvatar: 'Guardar Avatar',
    changePassword: 'Cambiar Contraseña',
    oldPassword: 'Contraseña Actual',
    newPassword: 'Contraseña Nueva',
    confirmNewPassword: 'Confirmar Contraseña Nueva',
    updatePassword: 'Actualizar Contraseña',
    saveName: 'Guardar Nombre',
    language: 'Idioma',
    saveLanguage: 'Guardar Idioma',
    english: 'Inglés',
    spanish: 'Español',
    seeOrganizationData: 'Ver Datos de la Organización',
    serviceStatus: 'Estado de Servicio',
    wolfieStatus: 'Estado de Chat de Mr. Wolf',
    wolfieSuggestions: 'Sugerencias de mensaje en Chat de Mr. Wolf',
    wolfieVoiceMode: 'Modo de voz de Chat de Mr. Wolf',
    wolfieAvatarMode: 'Modo de avatar de Chat de Mr. Wolf',
    wolfieDevPanel: 'Panel de desarrollo de Mr. Wolf',
    voiceMode: 'Modo de voz',
    avatarMode: 'Modo de avatar',
    configuration: 'Configuración',
    profile: 'Perfil',
    goToOrganization: 'Ir a los detalles de la organización',
    editName: 'Editar nombre',
    autoEnableMic: 'Micrófono después de responder',
    voiceActivation: 'Activación por Voz',
    manualOrgUpdate: 'Actualización manual de la organización',
    defaultOrganization: 'Organización Predeterminada',
    defaultOrganizationUpdated: 'Organización predeterminada actualizada exitosamente',
    yourOrganization: 'Tu Organización',
    yourOrganizations: 'Tus Organizaciones',
    sessionRecording: 'Grabación de Sesión',
    sessionRecordingUpdated: 'Preferencia de grabación de sesión actualizada exitosamente',
    profileInformation: 'Información del Perfil',
    organizationsManagement: 'Organizaciones',
    generalSettings: 'Configuración General',
    developerSettings: 'Configuración de Desarrollador',
    currentOrganization: 'Actual',
    switchToOrganization: 'Cambiar',
    leaveOrganization: 'Salir',
    editOrganization: 'Editar Org',
    noOrganizations: 'No se encontraron organizaciones',
    changePasswordDescription: 'Actualiza la contraseña de tu cuenta',
    sessionRecordingDescription: 'Gestionar preferencias de grabación de sesión',
    serviceStatusDescription: 'Ver el estado del sistema y la salud',
    wolfieStatusDescription: 'Activar o desactivar el asistente Mr. Wolf',
    autoEnableMicDescription: 'Activar automáticamente el micrófono después de que Mr. Wolf responda',
    voiceActivationDescription: 'Habilitar detección de palabra de activación para interacción sin manos',
    voiceModeDescription: 'Habilitar texto a voz para las respuestas de Mr. Wolf',
    avatarModeDescription: 'Mostrar avatar animado con Mr. Wolf',
    wolfieDevPanelDescription: 'Mostrar herramientas de desarrollador para depurar Mr. Wolf',
    manualOrgUpdateDescription: 'Activar manualmente la actualización de datos de organización para IA',
    manualOrgUpdateAllDescription: 'Activar manualmente la actualización de datos para todas las organizaciones',
    manualOrgUpdateAll: 'Actualización Manual de Todas las Organizaciones',
    updateNow: 'Actualizar Ahora',
    updateAllNow: 'Actualizar Todas Ahora',
    viewStatus: 'Ver Estado',
    launchTutorial: 'Iniciar Tutorial',
    launchTutorialDescription: 'Reiniciar el tutorial interactivo para aprender lo básico',
    startTutorial: 'Comenzar Tutorial',
    emailPreferences: 'Preferencias de Correo',
    emailPreferencesUpdated: 'Preferencias de correo actualizadas correctamente',
    marketingEmails: 'Correos de Marketing',
    marketingEmailsDescription: 'Recibir noticias, actualizaciones y contenido promocional',
    processReminders: 'Recordatorios de Procesos',
    processRemindersDescription: 'Recibir recordatorios sobre procesos programados y fechas límite',
    assignmentNotifications: 'Notificaciones de Asignación',
    assignmentNotificationsDescription: 'Recibir notificaciones cuando se te asigne a un proceso o tarea',
    organizationUpdates: 'Actualizaciones de Organización',
    organizationUpdatesDescription: 'Recibir notificaciones cuando seas agregado o removido de una organización',
    // New notification preferences
    notificationPreferences: 'Preferencias de Notificaciones',
    notificationPreferencesUpdated: 'Preferencias de notificaciones actualizadas correctamente',
    notificationChannelMail: 'Correo',
    notificationChannelBadge: 'Badge',
    notificationChannelSlack: 'Slack',
    underImplementation: 'En implementación',
    sharedBadgeTooltip: 'Este badge se comparte con notificaciones relacionadas',
    // Marketing Notifications
    marketingNotifications: 'Notificaciones de Marketing',
    marketingNotificationsDescription: 'Recibir noticias, actualizaciones y contenido promocional',
    // Assignment Notifications
    assignmentNotificationsTitle: 'Notificaciones de Asignación',
    assignmentNotificationsDesc: 'Recibir notificaciones cuando se te asigne a una ejecución de proceso',
    // Execution Reminders
    executionReminders: 'Recordatorios de Ejecución',
    executionRemindersDescription: 'Recibir recordatorios sobre asignaciones de ejecución pendientes',
    // Organization Changes
    organizationChanges: 'Cambios en Organización',
    organizationChangesDescription: 'Recibir notificaciones sobre actualizaciones de la organización',
    // Discrepancies
    discrepancies: 'Discrepancias',
    discrepanciesDescription: 'Recibir notificaciones sobre discrepancias en procesos',
    // Wolf Pendings
    wolfPendings: 'Pendientes de Mr. Wolf',
    wolfPendingsDescription: 'Recibir notificaciones sobre pendientes de Mr. Wolf',
    // Calendar Trigger Now
    calendarTrigger: 'Trigger de Calendario',
    calendarTriggerDescription: 'Recibir notificaciones cuando se disparan triggers de calendario',
    slackNotConnected: 'El administrador debe conectar Slack primero',
  },
  tutorial: {
    nextStep: 'Siguiente',
    previousStep: 'Atrás',
    skipTutorial: 'Saltar Tour',
    getStarted: 'Comenzar',
    gotIt: 'Entendido',
    stepCounter: 'Paso {current} de {total}',
    tutorialCompleted: 'Tutorial completado!',
    unableToCompleteTutorial: 'No se pudo completar el tutorial. Por favor, asegúrate de tener al menos un proceso creado.',
    welcome: {
      title: '¡Bienvenido a Mr. Wolf!',
      content: "Tour rápido de la app. ¡Vamos!",
    },
    sidebar: {
      title: 'Navegación',
      content: 'Usa esta barra lateral para navegar entre Procesos, Ejecuciones, Mapa de Procesos y más.',
    },
    executions: {
      title: 'Ejecuciones',
      content: 'Rastrea y gestiona las ejecuciones de procesos asignadas a ti o a tu equipo.',
    },
    requestExecution: {
      title: 'Solicitar Ejecución',
      content: 'Haz clic aquí para solicitar una nueva ejecución de este proceso y asignarla a un miembro del equipo.',
    },
    processes: {
      title: 'Procesos',
      content: 'Procedimientos paso a paso que definen cómo se realiza el trabajo en tu organización.',
    },
    processDescriptionSidebar: {
      title: 'Barra Lateral del Proceso',
      content: 'La barra lateral muestra el objetivo del proceso, categoría y todos los pasos. Haz clic en cualquier paso para ver sus detalles.',
    },
    processDescriptionContent: {
      title: 'Detalles del Paso',
      content: 'El área principal muestra la información detallada de cada paso, incluyendo descripciones, notas y acciones.',
    },
    triggers: {
      title: 'Disparadores',
      content: 'Los disparadores definen cuándo debe ocurrir la ejecución de un proceso. Los disparadores de evento responden a eventos específicos, mientras que los disparadores de calendario programan ejecuciones en horarios establecidos.',
    },
    executeButton: {
      title: 'Ejecutar Proceso',
      content: 'Haz clic aquí para comenzar a ejecutar este proceso tú mismo. Sigue tu progreso mientras completas cada paso.',
    },
    processMapOverview: {
      title: 'Mapa de Procesos',
      content: 'El Mapa de Procesos proporciona una vista general visual de todos tus procesos organizados por categoría. Puedes filtrar, buscar y navegar por los procesos de tu organización.',
    },
    processMapFilters: {
      title: 'Menú de Selección',
      content: 'Usa este menú para seleccionar qué Áreas, Servicios y Categorías mostrar en tu mapa de procesos.',
    },
    completion: {
      title: '¡Estás Listo!',
      content: 'Explora Procesos, solicita Ejecuciones y usa el Mapa de Procesos para visualizar tus flujos de trabajo. Reinicia este tour desde Configuración cuando quieras.',
    },
  },
  paywall: {
    currentlyFreeTierPlan: 'Actualmente en Plan Gratuito',
    paywallErrorDescription: 'Tu plan solo incluye un administrador y un usuario de solo lectura',
    upgradeTitle: 'Actualiza al Plan Profesional',
    upgradeSubtitle: 'Ideal para equipos que buscan colaboración ilimitada y gestión optimizada',
    includes: 'Incluye',
    allFreeTierFeatures: 'Todas las características del Plan Gratuito',
    additionalUsers: 'Usuarios adicionales según sea necesario',
    switchAnytime: 'Escalado flexible\n(agregar y eliminar asientos en cualquier momento)',
    adminUserPrice: '$15',
    adminUserPriceDescription: 'por usuario administrador/mes',
    readOnlyUserPrice: '$10',
    readOnlyUserPriceDescription: 'usuario de solo lectura/mes',
    cta: 'Actualizar plan',
  },
  seats: {
    noSeatsAvailable: 'No Hay Asientos Disponibles',
    noSeatsDescription: 'No tienes asientos disponibles.',
    noAdminSeatsAvailable: 'No Hay Asientos Admin Disponibles',
    noAdminSeatsDescription: 'No tienes asientos admin disponibles.',
    noUserSeatsAvailable: 'No Hay Asientos de Usuario Disponibles',
    noUserSeatsDescription: 'No tienes asientos de usuario disponibles.',
    addMoreSeatsTitle: 'Agregar Más Asientos',
    addMoreSeatsSubtitle: 'Escala tu equipo agregando más asientos a tu plan.',
    addMoreAdminSeatsTitle: 'Agregar Más Asientos Admin',
    addMoreAdminSeatsSubtitle: 'Necesitas agregar más asientos admin para asignar este rol. Ve a la página de facturación para agregar asientos admin a tu suscripción.',
    addMoreUserSeatsTitle: 'Agregar Más Asientos de Usuario',
    addMoreUserSeatsSubtitle: 'Necesitas agregar más asientos de usuario para asignar este rol. Ve a la página de facturación para agregar asientos de usuario a tu suscripción.',
    flexibleScaling: 'Escalado flexible de asientos',
    instantAccess: 'Acceso instantáneo para nuevos usuarios',
    cancelAnytime: 'Cancela en cualquier momento',
    proRatedBilling: 'Facturación prorrateada',
    addSeats: 'Agregar Asientos',
    addAdminSeats: 'Agregar Asientos Admin',
    addUserSeats: 'Agregar Asientos de Usuario',
  },
  common: {
    accept: 'Aceptar',
    action: 'Acción',
    actions: 'Acciones',
    active: 'Activo',
    add: 'Agregar',
    alert: 'Alerta',
    all: 'Todos',
    allAreas: 'Todas las áreas',
    alreadyEditing:
      'Ya estás editando un paso, por favor, guarda o cancela los cambios antes de continuar. Estas editando el paso:',
    area: 'Área',
    areas: 'Áreas',
    assign: 'Asignar',
    back: 'Volver',
    beginning: 'Inicio',
    cancel: 'Cancelar',
    cannotDelete: 'No se puede borrar al existir entidades relacionadas',
    case: 'Caso',
    category: 'Categoría',
    calendarIntegration: 'Integración de calendario activa',
    changesNotSaved: 'Tus cambios no han sido guardados aún.',
    cancelAndStayHere: 'Cancelar',
    saveAndLeave: 'Guardar',
    backToEditing: 'Volver a Editar',
    discardChanges: 'Descartar Cambios',
    change: "Cambiar",
    clear: 'Limpiar',
    clickDelete: 'Haz clic aquí para borrar',
    clickEdit: 'Haz clic aquí para editar',
    clickShowDoc: 'Haz clic para mostrar en Docs',
    clickShowMap: 'Haz clic para mostrar en el mapa de procesos',
    clickShowStorage: 'Haz clic para mostrar en la integración de almacenamiento',
    clickShowCalendar: 'Haz clic para mostrar en la integración de calendario',
    clickTo: 'Haz clic para',
    clickToAddOne: 'Haz clic para agregar uno',
    clickToAttachWolfie: 'Haz clic para adjuntar un archivo que utilice Mr. Wolf como base (Tamaño máx 5 MB)',
    clickView: 'Haz clic aquí para ver',
    clickViewGrid: 'Haz clic para ver en cuadrícula',
    clickViewList: 'Haz clic para ver en lista',
    clone: 'Clonar',
    close: 'Cerrar',
    collapse: 'Contraer',
    color: 'Color',
    condition: 'Condición',
    confirm: 'Confirmar',
    confirmLeave: 'Confirmar cerrar',
    date: 'Fecha',
    deleteProcess: 'Eliminar Proceso',
    deleteProcessConfirmation: 'Esto eliminará todos los pasos y triggers relacionados y <strong>no se puede deshacer</strong>.',
    deleteProcessQuestion: '¿Estás seguro de que quieres continuar?',
    yesDelete: 'Sí, Eliminar',
    comingSoon: 'Próximamente',
    comingSoonDescription: 'Esta funcionalidad no está disponible, por favor, inténtelo más tarde.',
    content: 'Contenido',
    create: 'Crear',
    custom: 'Personalizado',
    delete: 'Borrar',
    deleted: 'Eliminado',
    description: 'Descripción',
    disable: 'Desactivar',
    disabled: 'Desactivado',
    documents: 'Documentos',
    dragToReorder: 'Arrastra para reordenar',
    edit: 'Editar',
    email: 'Email',
    enable: 'Habilitar',
    enabled: 'Habilitado',
    end: 'Fin',
    expand: 'Expandir',
    export: 'Exportar',
    favorites: 'Destacados',
    filter: 'Filtrar',
    goal: 'Objetivo',
    help: 'Ayuda',
    impersonate: 'Suplantar',
    import: 'Importar',
    inside: 'Dentro',
    link: 'Vínculo',
    loop: 'Bucle',
    moveInside: 'Mover Adentro',
    moveOutside: 'Mover Afuera',
    name: 'Nombre',
    none: 'Ninguno',
    notNow: 'Ahora no',
    ok: 'OK',
    openDrawer: 'Abrir cajón lateral',
    openInNewTab: 'Abrir en nueva pestaña',
    optional: 'Opcional',
    options: 'Opciones',
    organization: 'Organización',
    owner: 'Propietario',
    owners: 'Propietarios',
    policy: 'Política',
    policies: 'Políticas',
    preview: 'Vista previa',
    process: 'Proceso',
    processMap: 'Mapa de Procesos',
    report: 'Reportar',
    requestError: 'Error en la solicitud de red',
    requestSuccess: 'Solicitud de red exitosa',
    required: 'Requerido',
    somethingWentWrong: 'Algo salió mal, por favor refresque e intente nuevamente.',
    save: 'Guardar',
    saving: 'Guardando',
    search: 'Buscar',
    select: 'Seleccionar',
    send: 'Enviar',
    service: 'Servicio',
    share: 'Compartir',
    show: 'Mostrar',
    showInDocs: 'Mostrar en Google Docs',
    status: 'Estado',
    step: 'Paso',
    steps: 'Pasos',
    allSteps: 'Todos los Pasos',
    substeps: 'Subpasos',
    of: 'de',
    storageIntegration: 'Integración de almacenamiento activa',
    submit: 'Enviar',
    suggestions: 'Sugerencias',
    toggleEdit: 'Alternar edición',
    uncategorized: 'Sin categoría',
    update: 'Actualizar',
    unsaved: 'sin guardar',
    withChanges: 'editando',
    uploading: 'Subiendo',
    user: 'Usuario',
    triggers: 'Desencadenadores',
    wolfie: 'Mr. Wolf',
    yes: 'Sí',
    first: 'Primer',
    second: 'Segundo',
    third: 'Tercer',
    fourth: 'Cuarto',
    last: 'Último',
    contactSupport: 'Contactar Soporte',
  },
  documents: {
    title: 'Documentos',
    addDocument: 'Subir documento',
    replaceDocument: 'Reemplazar documento',
    categoryInUse: 'Esta categoría está en uso, no se puede eliminar',
    upload: 'Enviar',
    uploadDocument: 'Subir documento',
    previewText: 'Vista previa',
    previewUpdateText: 'Vista previa del documento a actualizar (REEMPLAZA al anterior)',
    noPreview: 'No hay vista previa para este documento',
    confirmDelete: 'Confirmar borrado de documento',
    confirmDeleteMessage: '¿Está seguro que desea eliminar el documento?',
    cantDelete: 'This documento está vinculado a los siguientes pasos, desvincúlalo antes de eliminarlo',
    documentDisabledSuccessfully: 'Documento eliminado exitosamente',
    documentUpdatedSuccessfully: 'Documento actualizado exitosamente',
    downloadFile: 'Descargar archivo',
    owner: 'Owner',
    replaceWithNew: 'Reemplazar este archivo (actualiza el archivo manteniendo el mismo ID y los vínculos)',
    documentCategories: 'Categorías de documentos',
    documentPreview: 'Vista previa del documento',
    noVideoTag: 'Tu navegador no soporta el tag de video',
  },
  organizations: {
    title: 'Organizaciones',
    organization: 'Organización',
    userInfo: 'Información del usuario',
    ownersNames: 'Nombres de los propietarios',
    ownersEmails: 'Emails de los propietarios',
    addOrganization: 'Agregar organización',
    editOrganization: 'Editar organización',
    create: 'Crear',
    enableOrganization: 'Habilitar organización',
    disableOrganization: 'Desactivar organización',
    confirmDisableMessage: '¿Estás seguro de que quieres deshabilitar esta organización?',
    confirmEnableMessage: '¿Estás seguro de que quieres habilitar esta organización?',
    lastProfileUpdate: 'Última actualización de perfil',
    mainAreas: 'Áreas principales',
    troublesomeProcesses: 'Procesos complicados',
    onboardingStatus: 'Status de onboarding',
    skippedUntil: 'Omitir hasta',
    redoFTUE: 'Reiniciar entrevista',
    redoFTUEDescription: 'Reinicia la entrevista para actualizar tus datos de organización',
    interviewProfile: 'Perfil de entrevista',
    showOrganizationData: 'Haz clic para mostrar la página de perfil de la organización',
    pendingActions: 'Acciones pendientes',
    processCreation: 'Creación de procesos',
    stepCreation: 'Creación de pasos',
    shortDescriptionWarning: 'Funcionaríamos mejor con una descripción más larga',
    shortDescriptionMessage: 'Una descripción detallada ayuda a los miembros del equipo a comprender el propósito y los objetivos de la organización. Considera agregar más contexto sobre qué hace esta organización.',
    goBackAndAddMore: 'Agregar Más Detalles',
    skipDescription: 'Omitir / No Me Importa',
    descriptionEncouragement1: '¡Buen comienzo! Un poco más de detalle sería útil.',
    descriptionEncouragement2: '¡Gracias! Por favor agrega algo más de información.',
    descriptionEncouragement3: 'Suena como un buen comienzo, ¿quizás hay algo más de información que puedas agregar?',
    descriptionEncouragement4: 'Muy bien, si tienes más detalles relevantes siéntete libre de agregarlos.',
    descriptionEncouragement5: '¡Gracias!',
    seedOrganizationData: 'Poblar la organización con datos iniciales',
    seedOrganizationDataTooltip: 'Si está habilitado, se crearán datos de ejemplo (áreas, servicios, procesos) para esta organización para ayudarte a comenzar rápidamente.',
  },
  users: {
    title: 'Usuarios',
    role: 'Rol',
    status: 'Estado',
    firstName: 'Nombre',
    lastName: 'Apellido',
    addUser: 'Agregar usuario',
    disableUser: 'Deshabilitar usuario',
    editUser: 'Editar usuario',
    confirmDisableMessage: '¿Estás seguro de que quieres deshabilitar este usuario?',
    confirmEnableMessage: '¿Estás seguro de que quieres habilitar este usuario?',
    notAllowedToEdit: 'No tienes permisos para editar este usuario',
    firstUserRoleUser: 'La primer persona que agregues debe tener rol usuario.',
    ownerRoleModificationRestriction: 'El rol de propietario solo puede ser modificado por el equipo de soporte.',
    ownerRoleCannotBeSelected: 'El rol de propietario no puede ser seleccionado',
    locale: 'Idioma',
    assignSeat: 'Asignar Asiento',
    revokeSeat: 'Revocar Asiento',
    seatAssigned: 'Asiento asignado exitosamente',
    seatRevoked: 'Asiento revocado exitosamente',
    noSeatAvailable: 'No hay asientos disponibles',
    seatType: 'Tipo de Asiento',
    adminSeat: 'Asiento Admin',
    userSeat: 'Asiento Usuario',
    noSeat: 'Sin Asiento',
    assignSeatTitle: 'Asignar Asiento',
    revokeSeatTitle: 'Revocar Asiento',
    assignSeatMessage: '¿Estás seguro de que quieres asignar un asiento a este usuario?',
    revokeSeatMessage: '¿Estás seguro de que quieres revocar el asiento de este usuario?',
    seatError: 'Contacta a tu administrador para asignarte un asiento',
    unableToCreateUsers: 'No puedes crear usuarios hasta subir al plan premium',
    noSeatsAvailableMessage: 'No tienes asientos disponibles.',
    onlyUserSeatsAvailable: 'Solo puedes crear roles de "usuario" porque esos son los únicos asientos disponibles.',
    onlyAdminSeatsAvailable: 'Solo puedes crear roles de "admin" porque esos son los únicos asientos disponibles.',
    onlyUserSeatsAvailableRestriction: 'Solo el rol USUARIO está disponible debido a limitaciones de asientos. Actualiza tu plan para agregar usuarios ADMIN.',
    onlyAdminSeatsAvailableRestriction: 'Solo el rol ADMIN está disponible debido a limitaciones de asientos. Actualiza tu plan para agregar asientos de USUARIO.',
    goToBilling: 'Haz clic en agregar asientos para ir a la pagina de la suscripción y comprar más',
    upgradePlan: 'Mejorar plan',
    adminRoleRequiresUpgrade: 'El rol Admin requiere mejorar el plan.',
    seatsLeft: 'asientos disponibles',
    failedLoginAttempts: 'Intentos de inicio de sesión fallidos',
    resetFailedLoginAttempts: 'Restablecer intentos de inicio de sesión fallidos',
  },
  userOrganizations: {
    title: 'Organizaciones del Usuario',
    organizationsFor: 'Organizaciones de',
    addToOrganization: 'Agregar a Organización',
    loading: 'Cargando...',
    noOrganizations: 'Este usuario no es miembro de ninguna organización.',
    currentOrganizations: 'Organizaciones Actuales',
    previouslyBelongedTo: 'Perteneció Anteriormente A',
    lastRole: 'Último rol',
    removed: 'Removido',
    unknown: 'Desconocido',
    restoreToOrganization: 'Restaurar a Organización',
    restore: 'Restaurar',
    addUserToOrganization: 'Agregar Usuario a Organización',
    editRole: 'Editar Rol',
    removeFromOrganization: 'Remover de Organización',
    ownerRoleCannotBeModified: 'El rol de propietario no puede ser modificado',
    viewOnlyMessage: 'Solo puedes ver la información de organizaciones del usuario desde tu contexto de organización actual.',
  },
  wolfie: {
    minimize: 'Minimizar',
    expand: 'Expandir',
    collapse: 'Contraer',
    helpTooltip: 'El rayo a la izquierda activa los comandos rápidos para iniciar acciones disponibles. También puedes escribir "restart" para limpiar la conversación actual y comenzar de nuevo.',
    quickCommands: 'Comandos rápidos',
    attachFileTooltip: 'Adjuntar un archivo (PDF, DOC, DOCX, TXT) para generar un proceso a partir de su contenido',
    quickCommandCreateProcess: 'Quiero crear un proceso',
    quickCommandCreateProcessFromFile: 'Quiero crear un proceso desde un archivo existente',
    quickCommandWritePolicy: 'Quiero escribir una política',
    quickCommandKnowOrganization: 'Quiero saber más sobre mi organización',
    quickCommandRestart: 'Empezar nueva conversación',
    loading: 'Trabajando en la respuesta...',
    talk: 'Habilitar voz de Mr. Wolf',
    mute: 'Silenciar voz de Mr. Wolf',
    enableWakeWord: 'Habilitar palabra de activación "Hey Mr. Wolf"',
    disableWakeWord: 'Deshabilitar palabra de activación "Hey Mr. Wolf"',
    send: 'Enviar (también Ctrl+Enter o Cmd+Enter)',
    ftueMessage1: 'Bienvenido a Mr. Wolf',
    ftueMessage2: 'Comencemos conociendo tu organización.',
    ftueMessage3: 'Wolfie te guiará a través de una serie de preguntas para entender tu organización.',
    ftueMessage4: 'Luego procederemos a configurar los áreas de tu organización.',
    ftueMessage5: 'Por supuesto, puedes hacer cambios y pedirle a Mr. Wolf que ajuste los datos sugeridos.',
    ftueCancelButton: 'No gracias, no FTUE',
    ftueStartButton: 'OK, ¡vamos!',
    title: 'Perspectivas de Mr. Wolf',
    messagePlaceholder: 'Escribe tu mensaje aquí...',
    stopRecording: 'Click para detener grabación (también se detiene cuando estás silencioso por unos segundos)',
    startRecording: 'Click para empezar a grabar',
    loadingStage1a: 'Revisando tu mensaje...',
    loadingStage1b: 'Entendiendo tu solicitud...',
    loadingStage1c: 'Procesando entrada...',
    loadingStage2a: 'Verificando información de la organización...',
    loadingStage2b: 'Recopilando datos relevantes...',
    loadingStage2c: 'Buscando en base de conocimiento...',
    loadingStage3a: 'Analizando procesos actuales...',
    loadingStage3b: 'Analizando contexto...',
    loadingStage3c: 'Revisando políticas...',
    loadingStage4a: 'Procesando tu solicitud...',
    loadingStage4b: 'Considerando estructuras existentes...',
    loadingStage4c: 'Evaluando respuestas alternativas...',
    loadingStage5a: 'Preparando respuesta...',
    loadingStage5b: 'Finalizando respuesta...',
    loadingStage5c: 'Casi listo...',
    fileLoadingStage1a: 'Leyendo tu documento...',
    fileLoadingStage1b: 'Abriendo el archivo...',
    fileLoadingStage1c: 'Escaneando contenido del documento...',
    fileLoadingStage2a: 'Extrayendo texto del documento...',
    fileLoadingStage2b: 'Analizando estructura del documento...',
    fileLoadingStage2c: 'Analizando formato del documento...',
    fileLoadingStage3a: 'Identificando pasos del proceso...',
    fileLoadingStage3b: 'Buscando procedimientos...',
    fileLoadingStage3c: 'Detectando patrones de flujo de trabajo...',
    fileLoadingStage4a: 'Estructurando la información...',
    fileLoadingStage4b: 'Organizando datos extraídos...',
    fileLoadingStage4c: 'Construyendo esquema del proceso...',
    fileLoadingStage5a: 'Preparando tu proceso...',
    fileLoadingStage5b: 'Finalizando análisis del documento...',
    fileLoadingStage5c: 'Casi listo con tu proceso...',
    rateLimitError: 'Tu cuota para interactuar con Mr. Wolf se ha cumplido. Por favor intenta de nuevo después de las {time}.',
    rateLimitWarning: 'Estás llegando al límite de cuota de interacción con Mr. Wolf. Aún puedes enviar algunos mensajes. Luego serás limitado hasta que la cuota se reinicie en la próxima hora.',
    moveToTop: 'Mover Mr.Wolf Hub arriba',
    moveToBottom: 'Mover Mr.Wolf Hub abajo',
    showMessageWindow: 'Mostrar ventana de mensajes',
    hideMessageWindow: 'Esconder ventana de mensajes',
    fileSizeError: 'El archivo es demasiado grande. El tamaño máximo es 5MB.',
    fileRequiredError: 'Por favor selecciona un archivo.',
    processingError: 'Hubo un error al procesar tu archivo. Por favor intenta de nuevo.',
  },
  pricing: {
    cta: {
      readyToGetStarted: '¿Listo para comenzar?',
      tryFreeTier: 'Prueba el plan Gratuito ahora o',
      subscribeToProfessional: 'suscríbete al plan Professional para',
      unlockFullPotential: 'desbloquear todo el potencial.',
      startForFree: 'Comenzar Gratis',
      getProfessional: 'Obtener Professional',
    },
  },
  footer: {
    home: 'Inicio',
    learning: 'Aprendizaje',
    pricing: 'Precios',
    aboutUs: 'Sobre nosotros',
    termsAndConditions: 'Términos y Condiciones',
    privacyPolicy: 'Política de Privacidad',
    serviceStatus: 'Estado del Servicio',
    copyright: '© 2025 Mr.Wolf. Todos los derechos reservados.',
  },
  logRocket: {
    title: 'Consentimiento de Grabación de Sesión',
    description: 'Wolf utiliza LogRocket para ayudarnos a entender y resolver problemas más rápido mediante el registro de datos limitados de la sesión.',
    description2: '¿Aceptas esto y nos ayudas a brindar un mejor soporte?',
    accept: 'Aceptar',
    decline: 'Rechazar',
    statusAccepted: 'Aceptado',
    statusRejected: 'Rechazado',
  },
  billing: {
    billing: 'Facturación',
    sandboxMode: 'Ejecutando en Modo Sandbox',
    noStripeKeyNotice: 'La integración de pagos de Stripe aún no está habilitada. La funcionalidad de facturación no está disponible.',
    organizationInformation: 'Información de la Organización',
    billingContact: 'Contacto de Facturación',
    role: 'Rol',
    currentPlan: 'Plan Actual',
    freeTier: 'Plan Gratuito',
    freeTierDescription:
      'Actualmente estás en el plan Gratuito. Actualiza para acceder a más funciones y usuarios.',
    paidSubscription: 'Suscripción de Pago',
    subscriptionStartDate: 'Fecha de Inicio',
    manageSubscription: 'Administrar Suscripción',
    manageSubscriptionDescription: 'Modifica tu plan o actualiza la información de pago',
    managePaymentMethod: 'Gestionar Método de Pago',
    managePaymentMethodDescription: 'Actualizar tu tarjeta o información de facturación',
    modifyPlan: 'Modificar Plan',
    planUpgradeDescription: 'Desbloquea funciones adicionales con un plan Profesional',
    upgradePlan: 'Actualizar Plan',
    billingHistory: 'Historial de Facturación',
    noBillingHistory: 'No hay historial de facturación disponible',
    invoiceDescription: 'Factura de Suscripción',
    invoiceId: 'ID de Factura',
    invoiceDate: 'Fecha',
    modifySubscription: 'Modificar Suscripción',
    updateSubscription: 'Actualizar Suscripción',
    subscriptionUpdatedSuccess: 'Suscripción actualizada exitosamente',
    cancelSubscription: 'Cancelar Suscripción',
    cancelSubscriptionTitle: 'Cancelar Suscripción',
    cancelSubscriptionMessage: '¿Estás seguro de que quieres cancelar tu suscripción? Tu plan permanecerá activo hasta el final del período de facturación actual.',
    cancelSubscriptionWarning: 'Advertencia: Cuando finalice tu suscripción, todos los usuarios excepto el propietario y un usuario regular serán deshabilitados y no podrán acceder a la aplicación.',
    cancelImmediatelyLabel: 'Cancelar Inmediatamente',
    cancelImmediatelyDescription: 'Cancela ahora y pierde el acceso inmediatamente en lugar de al final del período de facturación',
    confirmCancel: 'Sí, Cancelar Suscripción',
    cancelling: 'Cancelando...',
    subscriptionCancelledSuccess: 'Suscripción cancelada exitosamente. Permanecerá activa hasta el final del período de facturación.',
    subscriptionCancelledImmediately: 'Suscripción cancelada inmediatamente',
    cancelAtPeriodEndTitle: 'Suscripción Finalizando',
    cancelAtPeriodEndMessage: 'Tu suscripción está configurada para cancelarse al final del período de facturación actual. No puedes modificarla o cancelarla durante este tiempo.',
    cancelAtPeriodEndInfo: 'Puedes crear una nueva suscripción después de que finalice el período actual.',
    createNewSubscription: 'Crear Nueva Suscripción',
    createNewSubscriptionDescription: 'Tu suscripción está cancelada. Crea una nueva suscripción para continuar usando el servicio.',
    selectSeats: 'Seleccionar Asientos',
    adminSeats: 'Asientos Admin',
    userSeats: 'Asientos Usuario',
    perSeatMonth: 'asiento/mes',
    adminSeatsDescription: 'Usuarios con acceso completo y privilegios de administrador',
    userSeatsDescription: 'Usuarios de solo lectura con acceso limitado',
    billingEmail: 'Email de Facturación',
    billingEmailPlaceholder: 'facturacion@empresa.com',
    billingEmailHelper: 'Las facturas y recibos se enviarán al correo electrónico del propietario de la organización.',
    totalMonthly: 'Total Mensual',
    billingRecurring: 'Facturado mensualmente. Cancela en cualquier momento.',
    continueToPayment: 'Continuar al Pago',
    priceConfigNotLoaded: 'Configuración de precios no cargada. Por favor, inténtelo de nuevo.',
    subscriptionSessionCreated: 'Sesión de suscripción creada exitosamente',
    subscriptionSummary: 'Resumen de Suscripción',
    paymentInformation: 'Información de Pago',
    securePaymentNotice:
      '🔒 Los pagos son procesados de forma segura por Stripe. La información de tu tarjeta nunca se almacena en nuestros servidores.',
    processing: 'Procesando...',
    confirmSubscription: 'Confirmar Suscripción',
    paymentFailed: 'Pago Fallido',
    errorDetails: 'Detalles del Error',
    adminSeatMinimumReached: 'No se puede reducir por debajo de los administradores actuales más uno para el propietario',
    userSeatMinimumReached: 'No se puede reducir por debajo del número de usuarios actualmente en uso',
    adminSeatLimitReached: 'Si necesitas más administradores, por favor contáctanos en info@mrwolfapp.com',
    userSeatLimitReached: 'Si necesitas más usuarios, por favor contáctanos en info@mrwolfapp.com',
    inUse: 'en uso',
    cancellationDate: 'Fecha de Cancelación',
    subscriptionLoadError: 'No se Pudo Cargar los Detalles de la Suscripción',
    couponCode: 'Código de Cupón',
    couponCodePlaceholder: 'Ingrese código de cupón',
    couponCodeHelper: 'Opcional: Ingrese un código promocional para aplicar un descuento',
    applyCoupon: 'Aplicar Cupón',
    validateCoupon: 'Validar',
    couponApplied: 'Cupón aplicado exitosamente',
    invalidCoupon: 'Código de cupón inválido',
    removeCoupon: 'Eliminar Cupón',
    validatingCoupon: 'Validando...',
    couponValidationSuccess: '¡Cupón válido!',
    couponDiscountApplied: 'Descuento Aplicado',
    originalPrice: 'Precio Original',
    discount: 'Descuento',
    finalPrice: 'Precio Final',
    percentOff: 'de descuento',
    durationOnce: 'descuento único',
    durationRepeating: 'descuento recurrente',
    durationRepeatingOneMonth: 'por 1 mes',
    durationRepeatingMonths: 'por {months} meses',
    durationForever: 'descuento permanente',
  },
  subscriptions: {
    subscriptions: 'Suscripciones',
    sandboxMode: 'Ejecutando en Modo Sandbox',
    noStripeKeyNotice: 'La integración de pagos de Stripe aún no está habilitada. La funcionalidad de suscripciones no está disponible.',
    totalMRR: 'MRR Total',
    activeSubscriptions: 'Suscripciones Activas',
    trialSubscriptions: 'Suscripciones de Prueba',
    allSubscriptions: 'Todas las Suscripciones',
    plan: 'Plan',
    status: 'Estado',
    active: 'Activo',
    trial: 'Prueba',
    canceled: 'Cancelado',
    pastDue: 'Vencido',
    users: 'Usuarios',
    adminSeats: 'Asientos Admin',
    userSeats: 'Asientos Usuario',
    totalSeats: 'Total Asientos',
    monthlyRevenue: 'Ingresos Mensuales',
    createdAt: 'Creado',
    updatedAt: 'Actualizado',
    noSubscriptions: 'No se encontraron suscripciones',
    note: 'Nota',
    cancelAtPeriodEndTooltip: 'Esta suscripción se cancelará al final del período de facturación actual',
  },
};

export default es;
